import { useCookie } from './useCookie'

/**
 * Hook for creating dismissible notices that are persisted via cookies
 *
 * @param key - Unique key for the notice (used as cookie key)
 * @param defaultValue - Initial dismissed state (default: false)
 * @returns Object with isDismissed state and dismiss function
 */
export function useDismissible(
  key: string,
  defaultValue: boolean = false,
  options: { session?: boolean } = {
    session: false,
  }
) {
  const [isDismissed, setIsDismissed] = useCookie(
    key,
    defaultValue,
    options.session
  )

  const dismiss = (options: { maxAge?: number | undefined } = {}) =>
    setIsDismissed(true, options)

  return {
    isDismissed,
    dismiss,
  }
}

export default useDismissible
